module.exports = __webpack_public_path__ + "static/img/Thomas.3601bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/vantage/Thomas.png
// module id = 3GyL
// module chunks = 0